<!DOCTYPE html>
<html lang="zh-CN">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>概览 - ASODIG</title>
  <link rel="stylesheet" href="/topbar.css">
  <link rel="stylesheet" href="/app-keywords-theme.css">
  <script defer type="module" src="/topbar.js"></script>
  <script src="https://cdn.tailwindcss.com"></script>
  <script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
  <style>
    .ak-dashboard-head {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
    }
    .ak-dashboard-title {
      font-size: 18px;
      font-weight: 700;
      color: var(--ak-text);
      letter-spacing: 0.2px;
    }
    .ak-dashboard-sub {
      font-size: 12px;
      color: var(--ak-sub);
      margin-top: 2px;
      line-height: 1.35;
    }
    .ak-kpi {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-height: 86px;
    }
    .ak-kpi-label {
      font-size: 12px;
      color: var(--ak-sub);
    }
    .ak-kpi-value {
      font-size: 24px;
      font-weight: 700;
      color: var(--ak-text);
      line-height: 1.05;
      font-variant-numeric: tabular-nums;
      letter-spacing: 0.2px;
    }
    .ak-kpi-value.is-time {
      font-size: 18px;
      letter-spacing: 0;
    }
    .ak-kpi-hint {
      font-size: 12px;
      color: rgba(107, 114, 128, 0.92);
      line-height: 1.35;
    }
	    .ak-chart-wrap {
	      position: relative;
	      height: 240px;
	      margin-top: 6px;
	      border-radius: 12px;
	      border: 1px solid rgba(60, 60, 67, 0.08);
	      background: rgba(60, 60, 67, 0.02);
	      overflow: hidden;
	    }
	    .ak-chart-canvas {
	      width: 100% !important;
	      height: 100% !important;
	    }
    @media (max-width: 640px) {
      .ak-kpi {
        min-height: 78px;
      }
      .ak-chart-wrap {
        height: 220px;
      }
      .ak-chart-canvas {
        height: 220px;
      }
    }
  </style>
</head>
<body class="ak-page">
  <main class="ak-layout">
    <section class="ak-card">
      <div class="ak-section">
        <div class="ak-dashboard-head">
          <div>
            <div class="ak-dashboard-title">概览仪表盘</div>
            <div class="ak-dashboard-sub">仅展示系统级汇总指标（关键词快照 / 榜单快照）。</div>
          </div>
          <div class="ak-section-actions">
            <div id="dataState" class="ak-meta">--</div>
            <button id="refreshBtn" class="ak-btn soft ak-accent">刷新</button>
          </div>
        </div>
      </div>
    </section>

    <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">关键词快照总数</div>
          <div id="kpiKeywordSnapshots" class="ak-kpi-value">-</div>
          <div id="kpiKeywordSnapshotsHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">24h 关键词快照</div>
          <div id="kpiKeyword24h" class="ak-kpi-value">-</div>
          <div id="kpiKeyword24hHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">监控关键词数</div>
          <div id="kpiKeywords" class="ak-kpi-value">-</div>
          <div id="kpiKeywordsHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">覆盖地区数</div>
          <div id="kpiStorefronts" class="ak-kpi-value">-</div>
          <div id="kpiStorefrontsHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">榜单组合数</div>
          <div id="kpiChartGroups" class="ak-kpi-value">-</div>
          <div id="kpiChartGroupsHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">榜单快照总数</div>
          <div id="kpiChartSnapshots" class="ak-kpi-value">-</div>
          <div id="kpiChartSnapshotsHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">榜单最新抓取</div>
          <div id="kpiChartLatest" class="ak-kpi-value is-time">-</div>
          <div id="kpiChartLatestHint" class="ak-kpi-hint"></div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section ak-kpi">
          <div class="ak-kpi-label">完整榜单率</div>
          <div id="kpiChartFullRate" class="ak-kpi-value">-</div>
          <div id="kpiChartFullRateHint" class="ak-kpi-hint"></div>
        </div>
      </div>
    </section>

    <section class="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <div class="ak-card">
        <div class="ak-section">
          <div class="ak-section-head">
            <div>
              <div class="ak-section-title">榜单类型分布</div>
              <div class="ak-section-sub">按“榜单组合”统计</div>
            </div>
            <div id="chartTypeMeta" class="ak-meta">--</div>
          </div>
          <div class="ak-chart-wrap">
            <canvas id="chartTypeCanvas" class="ak-chart-canvas"></canvas>
          </div>
        </div>
      </div>
      <div class="ak-card">
        <div class="ak-section">
          <div class="ak-section-head">
            <div>
              <div class="ak-section-title">榜单更新分布</div>
              <div class="ak-section-sub">按“最新抓取时间”分桶</div>
            </div>
            <div id="freshnessMeta" class="ak-meta">--</div>
          </div>
          <div class="ak-chart-wrap">
            <canvas id="freshnessCanvas" class="ak-chart-canvas"></canvas>
          </div>
        </div>
      </div>
    </section>
  </main>

  <script>
    let chartTypeChart = null;
    let freshnessChart = null;

    function $(id) {
      return document.getElementById(id);
    }

    function formatNumber(n) {
      if (typeof n !== 'number' || !Number.isFinite(n)) return '-';
      return n.toLocaleString('zh-CN');
    }

    function formatDateTime(dateLike) {
      const d = new Date(dateLike);
      if (Number.isNaN(d.getTime())) return '-';
      return d.toLocaleString('zh-CN', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    function formatRelative(ms) {
      if (typeof ms !== 'number' || !Number.isFinite(ms)) return '-';
      if (ms < 45 * 1000) return '刚刚';
      const minutes = Math.floor(ms / 60000);
      if (minutes < 60) return `${minutes} 分钟前`;
      const hours = Math.floor(ms / 3600000);
      if (hours < 24) return `${hours} 小时前`;
      const days = Math.floor(ms / 86400000);
      return `${days} 天前`;
    }

	    function cssVar(name, fallback) {
	      const raw = getComputedStyle(document.body).getPropertyValue(name);
	      const v = String(raw || '').trim();
	      return v || fallback;
	    }

	    function getChartTheme() {
	      const akSub = cssVar('--ak-sub', '#6b7280');
	      const akText = cssVar('--ak-text', '#111827');
	      const akPrimary = cssVar('--ak-primary', '#007aff');
	      return {
	        akSub,
	        akText,
	        akPrimary,
	        grid: 'rgba(60, 60, 67, 0.08)',
	        tooltip: {
	          backgroundColor: 'rgba(255, 255, 255, 0.96)',
	          borderColor: 'rgba(60, 60, 67, 0.16)',
	          borderWidth: 1,
	          cornerRadius: 12,
	          padding: 10,
	          caretSize: 6,
	          caretPadding: 8,
	          titleColor: akText,
	          bodyColor: akText,
	          titleFont: { size: 12, weight: '600' },
	          bodyFont: { size: 12, weight: '500' },
	        },
	      };
	    }

    function normalizeChartType(ct) {
      const s = String(ct || '').toLowerCase();
      if (s === 'top-free') return { key: 'free', label: '免费榜' };
      if (s === 'top-paid') return { key: 'paid', label: '付费榜' };
      if (s === 'top-grossing') return { key: 'gross', label: '畅销榜' };
      return { key: 'other', label: ct || '其他' };
    }

    async function fetchJson(url, { timeoutMs = 12000 } = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), timeoutMs);
      try {
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
      } finally {
        clearTimeout(timer);
      }
    }

	    function renderChartType(groups) {
	      const map = new Map();
	      for (const g of groups) {
	        const { label } = normalizeChartType(g.chartType);
	        map.set(label, (map.get(label) || 0) + 1);
	      }
	      const labels = Array.from(map.keys());
	      const values = labels.map((l) => map.get(l) || 0);

	      const palette = {
	        '免费榜': '#007aff',
	        '付费榜': '#34c759',
	        '畅销榜': '#ff9f0a',
	      };
	      const colors = labels.map((l) => palette[l] || '#8e8e93');

	      const theme = getChartTheme();
	      const { akSub, akText } = theme;

	      if (chartTypeChart) chartTypeChart.destroy();
	      const ctx = $('chartTypeCanvas').getContext('2d');
	      chartTypeChart = new Chart(ctx, {
	        type: 'doughnut',
        data: {
          labels,
          datasets: [
	            {
	              data: values,
	              backgroundColor: colors,
	              borderColor: '#ffffff',
	              borderWidth: 1,
	              hoverOffset: 4,
	            },
	          ],
	        },
	        options: {
	          responsive: true,
	          maintainAspectRatio: false,
	          layout: { padding: { top: 8, bottom: 0, left: 8, right: 8 } },
	          plugins: {
	            legend: {
	              position: 'bottom',
	              labels: {
	                color: akSub,
	                usePointStyle: true,
	                pointStyle: 'circle',
	                boxWidth: 6,
	                boxHeight: 6,
	                padding: 14,
	                font: { size: 12, weight: '500' },
	              },
	            },
	            tooltip: {
	              callbacks: {
	                label: (ctx) => `${ctx.label}: ${ctx.formattedValue}`,
	              },
	              ...theme.tooltip,
	              displayColors: true,
	              boxPadding: 6,
	            },
	          },
	          cutout: '68%',
	        },
	      });

	      $('chartTypeMeta').textContent = labels.length ? `${formatNumber(groups.length)} 组` : '暂无数据';
	    }

	    function renderFreshness(groups) {
	      const now = Date.now();
	      const buckets = [
	        { label: '≤6小时', max: 6 * 3600000 },
	        { label: '≤24小时', max: 24 * 3600000 },
	        { label: '≤3天', max: 3 * 86400000 },
	        { label: '≤7天', max: 7 * 86400000 },
	        { label: '>7天', max: Infinity },
	      ];

      const counts = new Array(buckets.length).fill(0);
      let latestAt = 0;
      for (const g of groups) {
        const t = new Date(g.capturedAt).getTime();
        if (!Number.isFinite(t)) continue;
        if (t > latestAt) latestAt = t;
        const age = Math.max(0, now - t);
        const idx = buckets.findIndex((b) => age <= b.max);
        if (idx >= 0) counts[idx] += 1;
      }

	      const theme = getChartTheme();
	      const { akSub, akText, akPrimary } = theme;
	      const baseFill = 'rgba(0, 122, 255, 0.22)';
	      const baseBorder = 'rgba(0, 122, 255, 0.55)';
	      const staleFill = 'rgba(255, 59, 48, 0.18)';
	      const staleBorder = 'rgba(255, 59, 48, 0.55)';
	      const colors = counts.map((v, idx) => (idx === buckets.length - 1 && v > 0 ? staleFill : baseFill));
	      const borderColors = counts.map((v, idx) => (idx === buckets.length - 1 && v > 0 ? staleBorder : baseBorder));

	      if (freshnessChart) freshnessChart.destroy();
	      const ctx = $('freshnessCanvas').getContext('2d');
	      freshnessChart = new Chart(ctx, {
	        type: 'bar',
	        data: {
	          labels: buckets.map((b) => b.label),
	          datasets: [
	            {
	              data: counts,
	              backgroundColor: colors,
	              borderColor: borderColors,
	              borderWidth: 1,
	              borderRadius: 10,
	              borderSkipped: false,
	              maxBarThickness: 44,
	            },
	          ],
	        },
	        options: {
	          responsive: true,
	          maintainAspectRatio: false,
	          layout: { padding: { top: 10, bottom: 6, left: 8, right: 8 } },
	          plugins: {
	            legend: { display: false },
	            tooltip: {
	              callbacks: {
	                label: (ctx) => `组合数: ${ctx.formattedValue}`,
	              },
	              ...theme.tooltip,
	              displayColors: false,
	            },
	          },
	          scales: {
	            x: {
	              ticks: { color: akSub, font: { size: 11, weight: '500' } },
	              grid: { display: false },
	              border: { display: false },
	            },
	            y: {
	              beginAtZero: true,
	              ticks: { color: akSub, precision: 0, font: { size: 11, weight: '500' } },
	              grid: { color: theme.grid },
	              border: { display: false },
	            },
	          },
	        },
	      });

      $('freshnessMeta').textContent = latestAt ? `最新：${formatDateTime(latestAt)}` : '暂无数据';
    }

    function setText(id, text) {
      const el = $(id);
      if (el) el.textContent = text ?? '';
    }

    async function loadDashboard() {
      const btn = $('refreshBtn');
      if (btn) btn.disabled = true;
      setText('dataState', '刷新中…');

      const [statsRes, groupsRes] = await Promise.allSettled([
        fetchJson('/api/stats'),
        fetchJson('/api/charts/groups'),
      ]);

      const okStats = statsRes.status === 'fulfilled';
      const okGroups = groupsRes.status === 'fulfilled';

      if (okStats) {
        const s = statsRes.value || {};
        const totalSnapshots = Number(s.totalSnapshots) || 0;
        const uniqueKeywords = Number(s.uniqueKeywords) || 0;
        const uniqueStorefronts = Number(s.uniqueStorefronts) || 0;
        const last24hSnapshots = Number(s.last24hSnapshots) || 0;

        setText('kpiKeywordSnapshots', formatNumber(totalSnapshots));
        setText('kpiKeywordSnapshotsHint', `近24h：${formatNumber(last24hSnapshots)}`);
        setText('kpiKeyword24h', formatNumber(last24hSnapshots));
        setText('kpiKeyword24hHint', totalSnapshots ? `占比：${Math.round((last24hSnapshots / totalSnapshots) * 100)}%` : '');
        setText('kpiKeywords', formatNumber(uniqueKeywords));
        setText('kpiKeywordsHint', uniqueStorefronts ? `覆盖 ${formatNumber(uniqueStorefronts)} 个地区` : '');
        setText('kpiStorefronts', formatNumber(uniqueStorefronts));
        setText('kpiStorefrontsHint', uniqueKeywords ? `覆盖 ${formatNumber(uniqueKeywords)} 个关键词` : '');
      } else {
        setText('kpiKeywordSnapshots', '-');
        setText('kpiKeywordSnapshotsHint', '');
        setText('kpiKeyword24h', '-');
        setText('kpiKeyword24hHint', '');
        setText('kpiKeywords', '-');
        setText('kpiKeywordsHint', '');
        setText('kpiStorefronts', '-');
        setText('kpiStorefrontsHint', '');
      }

      if (okGroups) {
        const groups = Array.isArray(groupsRes.value) ? groupsRes.value : [];
        const groupCount = groups.length;
        const snapshotTotal = groups.reduce((sum, g) => sum + (Number(g.snapshotCount) || 0), 0);
        const fullCount = groups.reduce((sum, g) => sum + (g.fullLoaded ? 1 : 0), 0);
        const fullRate = groupCount ? Math.round((fullCount / groupCount) * 100) : 0;

        let latestAt = 0;
        for (const g of groups) {
          const t = new Date(g.capturedAt).getTime();
          if (Number.isFinite(t) && t > latestAt) latestAt = t;
        }
        const age = latestAt ? Date.now() - latestAt : null;

        setText('kpiChartGroups', formatNumber(groupCount));
        setText('kpiChartGroupsHint', '地区/分类/榜单组合');
        setText('kpiChartSnapshots', formatNumber(snapshotTotal));
        setText('kpiChartSnapshotsHint', groupCount ? `平均每组：${formatNumber(Math.round(snapshotTotal / groupCount))}` : '');
        setText('kpiChartLatest', latestAt ? formatRelative(age) : '-');
        setText('kpiChartLatestHint', latestAt ? `时间：${formatDateTime(latestAt)}` : '');
        setText('kpiChartFullRate', groupCount ? `${fullRate}%` : '-');
        setText('kpiChartFullRateHint', groupCount ? `${formatNumber(fullCount)} / ${formatNumber(groupCount)}` : '');

        renderChartType(groups);
        renderFreshness(groups);
      } else {
        setText('kpiChartGroups', '-');
        setText('kpiChartGroupsHint', '');
        setText('kpiChartSnapshots', '-');
        setText('kpiChartSnapshotsHint', '');
        setText('kpiChartLatest', '-');
        setText('kpiChartLatestHint', '');
        setText('kpiChartFullRate', '-');
        setText('kpiChartFullRateHint', '');
        setText('chartTypeMeta', '加载失败');
        setText('freshnessMeta', '加载失败');
        if (chartTypeChart) chartTypeChart.destroy();
        if (freshnessChart) freshnessChart.destroy();
        chartTypeChart = null;
        freshnessChart = null;
      }

      const nowText = formatDateTime(Date.now());
      setText(
        'dataState',
        `最后刷新：${nowText}（关键词：${okStats ? 'OK' : '失败'} / 榜单：${okGroups ? 'OK' : '失败'}）`,
      );
      if (btn) btn.disabled = false;
    }

    $('refreshBtn').addEventListener('click', loadDashboard);
    loadDashboard();
  </script>
</body>
</html>
